import script from "./InstallData.vue?vue&type=script&setup=true&lang=js"
export * from "./InstallData.vue?vue&type=script&setup=true&lang=js"

import "./InstallData.vue?vue&type=style&index=0&id=5a3b606a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a3b606a"]])

export default __exports__